<script>
    import { emeters, devices, integrated_list } from "../stores";
    import Emeter from "./Emeter.svelte";
    export let selected = [];

</script>

<div style={`height: calc(${$devices.length}*50px)`}>
    {#each $devices as device}
        <Emeter 
                {device} 
                checked={selected.includes(device.id)}
                on:update_selection   
            />
    {/each}
</div>


<style>
    div{
        display: flex;
        width: 100%;
        max-height: 85% ;
        flex-direction: column;
        align-items: center;
        
        margin-bottom: 1em;
        box-sizing: border-box;
       
        overflow-y: auto;
        scrollbar-width: thin;
        scrollbar-color: var(--color_scheme-contrast_color_3) #555;
    
    }
        

    ::-webkit-scrollbar {
        width: 0.15em;
    }

    ::-webkit-scrollbar-track {
        background: #f1f1f1; 
    }
        
    ::-webkit-scrollbar-thumb {
        background: var(--color_scheme-contrast_color_3); 
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #555; 
    }
</style>